const Global = {};

Global.app = {
  didRun: window.localStorage.getItem("didRun") === "true" ? true : false,
  topColor: "white",
  bottomColor: "white",
};

Global.personal = {};

Global.test = process.env.REACT_APP_TEST === "true" ? true : false;

Global.comName = process.env.REACT_APP_COM_NAME;
Global.appName = process.env.REACT_APP_APP_NAME;
Global.mode = process.env.NODE_ENV;

Global.thinkPoolServer = process.env.REACT_APP_THINKPOOL_URL;

Global.myApiId = process.env.REACT_MYAPI_ID;
Global.myApiSecretKey = process.env.REACT_MYAPI_SECRET_KEY;

if (Global.mode === "development") {
  Global.server = process.env.REACT_APP_SERVER;
  Global.env = process.env;
} else {
  Global.server = window.location.origin;
}

Global.data = {};
Global.views = {};
Global.states = [];

Global.sessionTimerReset = {};
Global.slideLoadingStopMs = 500;

window.App = Global;

export default Global;
